


export type PromiseArg<T> = T extends PromiseLike<infer U> ? U : T

export const asyncDebounce = <T extends (...args: any) => Promise<any>>(inner: T, ms: number = 0) => {
    let timer: any = null;
    let resolves: any = [];

    return function (...args: Parameters<T>) {
        // Run the function after a certain amount of time
        clearTimeout(timer);

        timer = setTimeout(async () => {
            let relatedResolves = [...resolves];
            resolves = [];

            // Get the result of the inner function, then apply it to the resolve function of
            // each promise that has been created since the last time the inner function was run
            let result = await inner(...(args as any));

            relatedResolves.forEach((r: (data: PromiseArg<ReturnType<T>>) => void) => r(result));
        }, ms);

        return new Promise<PromiseArg<ReturnType<T>>>(r => resolves.push(r));
    };
}

export default asyncDebounce